import React from 'react';

export const indusWarningComponent = (pModule: string) => {
  return (
    pModule === 'indus' && (
      <div style={{ float: 'left' }}>
        <span style={{ fontSize: '12px' }}>
          (max 1 000 entreprises affichées)
        </span>
      </div>
    )
  );
};
